import styled from 'styled-components';

export const Settings = styled.div`
  padding: 25px 55px 25px 25px;
  width: 320px;
  box-sizing: content-box;
`;

export const TagManager = styled.div`
  margin-top: 10px;
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
`;

export const Cancel = styled.div`
  margin-left: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
